var AGE_GROUP = {}

var STATUS = {
  default: 0,
  preretirement: 1,
  retirement: 2
}

var SEX = {
  male: 'male',
  female: 'female'
}

const MAX_PAY = 12792
const MIN_PAY = 1500

AGE_GROUP[SEX.male] = [
  {
    label: '1958 и старше',
    preretirement: null,
    retirement: 60,
    value: 1958
  },
  {
    label: '1959',
    preretirement: 55.5,
    retirement: 60.5,
    value: 1959
  },
  {
    label: '1960',
    preretirement: 56.5,
    retirement: 61.5,
    value: 1960
  },
  {
    label: '1961',
    preretirement: 58,
    retirement: 63,
    value: 1961
  },
  {
    label: '1962',
    preretirement: 59,
    retirement: 64,
    value: 1962
  },
  {
    label: '1963 и младше',
    preretirement: 60,
    retirement: 65,
    value: 1963
  }
].sort(function (a, b) {
  return b.value - a.value
})

AGE_GROUP[SEX.female] = [
  {
    label: '1963 и старше',
    preretirement: null,
    retirement: 55,
    value: 1963
  },
  {
    label: '1964',
    preretirement: 50.5,
    retirement: 55.5,
    value: 1964
  },
  {
    label: '1965',
    preretirement: 51.5,
    retirement: 56.5,
    value: 1965
  },
  {
    label: '1966',
    preretirement: 53,
    retirement: 58,
    value: 1966
  },
  {
    label: '1967',
    preretirement: 54,
    retirement: 59,
    value: 1967
  },
  {
    label: '1968 и младше',
    preretirement: 55,
    retirement: 60,
    value: 1968
  }
].sort(function (a, b) {
  return b.value - a.value
})

var REASON = [
  {
    value: 1,
    label: 'Ранее не работал',
  },
  {
    value: 2,
    label: 'Завершил предпринимательскую деятельность или вышел из членов крестьянского (фермерского) хозяйства',
  },
  {
    value: 3,
    label: 'Уволен за нарушения трудовой дисциплины',
  },
  {
    value: 4,
    label: 'Уволен менее года назад и был в трудовых отношениях не менее 26-и недель',
  },
  {
    value: 5,
    label: 'Уволен более года назад, в том числе с военной службы',
  },
  {
    value: 6,
    label: 'Уволен с военной службы менее года назад и был в трудовых отношениях не менее 26-и недель в течение года до призыва',
  },
]


Vue.component('v-calcposobie', {
  data: function () {
    return {
      SEX: SEX,
      STATUS: STATUS,
      AGE_GROUP: AGE_GROUP,
      REASON: REASON,
      //
      sex: SEX.male,
      ageGroup: null,
      ageGroupStatus: null,
      ageGroupOpen: false,
      userStatus: null,
      reason: '',
      pay: ''
    }
  },
  methods: {
    applySex(sex) {
      console.log('sex', sex)
      this.sex = sex
      this.applyAgeGroup(null)
    },
    applyAgeGroup(group) {
      this.ageGroup = group
      this.setStatus(null)
      this.closeAgeGroup()
    },
    openAgeGroup() {
      this.ageGroupOpen = true
    },
    toggleAgeGroup() {
      this.ageGroupOpen = !this.ageGroupOpen
    },
    closeAgeGroup() {
      this.ageGroupOpen = false
    },
    setStatus(status) {
      this.userStatus = status
    },
    hasReason(reasons) {
      if (this.reason) {
        return reasons.includes(this.reason)
      }
    },
    calcPayment(multiplier, max) {
      if (this.validPay) {
        var maxResult = max ? max : MAX_PAY
        var minResult = MIN_PAY

        var sum = this.pay * multiplier
        var result = Math.floor(sum * 100) / 100

        if (result > maxResult) result = maxResult
        else if (result < minResult) result = minResult

        return result.toLocaleString() + ' руб.'
      }
    },
  },
  computed: {
    validPay() {
      return this.pay && Number.isInteger(+this.pay)
    },
    age() {
      if (!this.ageGroup) {
        return
      }

      var year = new Date().getFullYear()
      return year - this.ageGroup.value
    },
    status() {
      if (!this.ageGroup) {
        return
      }

      if (this.userStatus !== null) {
        return this.userStatus
      }

      switch (true) {
        case this.age < this.ageGroup.preretirement:
          return STATUS.default
        case this.age >= this.ageGroup.preretirement && this.age < this.ageGroup.retirement:
          return STATUS.preretirement
        case this.age >= this.ageGroup.retirement:
          return STATUS.retirement
      }
    }
  }
})